<template>
    <div class="flex flex-col h-full w-full justify-center">
        <div class="flex mx-auto max-w-4xl container
        flex-col-reverse tablet:flex-row shadow-modal border-1 border-grey-light">
            <div
            class="tablet:w-1/2 tablet:border-r tablet:border-gray-300 p-5 tablet:p-10
            flex flex-col justify-between"
            >
                <h1 class="mb-5 tablet:mb-3">nomado access</h1>
                <input type="text" placeholder="Your work email"
                class="p-3 border rounded"
                 />
                <input type="password" placeholder="Your password"
                class="p-3 mt-3 tablet:mt-2 border rounded"
                />
                <div class="flex flex-col mt-3">
                    <a href="#"
                    class="button-primary">
                        log in
                    </a>
                    <a href="#" class="mt-2 text-center tablet:text-left">Forgot Password?</a>
                </div>
                <p class="mt-5 text-center tablet:text-left">
                    Don't have nomado account?
                    <router-link :to="{ name: 'signup' }">Sign Up</router-link>
                </p>
        </div>
        <div class="flex flex-col p-5 tablet:p-10 tablet:w-1/2">
            <img src="@/assets/nomado-trunk.svg"
            class="hidden tablet:block"
             />
            <div class="mt-10">
                <span class="text-xs bg-blue text-white px-2 py-1 rounded">
                    new
                </span>
                <div class="flex items-center justify-between">
                    <h2 class="">nomado trunk - now available!
                    </h2>
                    <i class="fas fa-external-link-alt p-2 tablet:hidden"></i>
                </div>
                <p class="hidden tablet:block text-grey-light font-light">
                    Unlimited concurrent calls with pay-as-you-go charges.
                    Your voip structure will be ready to connect to the whole world in minutes.
                </p>
            </div>
            <a href="#" class="hidden tablet:block mt-5">Learn more</a>
        </div>
  </div>
    </div>
</template>

<script>
export default {
    name: 'login-form',
    props: {
        msg: String
    }
};
</script>

<style lang="scss">

</style>
